




















import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class Nota extends Vue {
  private onClick() {
    this.$store.commit("reset");
    this.$router.push("/");
  }
}
